<template>
  <section class="section-index-table">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="restrictions-settings">
            <div v-if="stations !== null" class="col-12 col-md-auto">
              <div class="search-restrictions">
                <label for="search-restrictions-input">Выберите станцию</label>
                <select v-model="stationId">
                  <option v-for="station in stations" v-bind:key="station.id" v-bind:value="station.id">
                    {{ station.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div style="margin-top: 18px;">
                <flat-pickr
                  v-model="dateTime"
                  :config="pickerConfig"
                  class="form-control"
                  placeholder="Выберите дату"
                  name="date"></flat-pickr>
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div class="confirm-restrictions">
                <div class="confirm confirm-restrictions__button count-restrictions__button" style="width:auto;" @click="getPower()">Получить мощность</div>
              </div>
            </div>
            <div v-if="momentPower !== null" class="col-12 col-md-auto">
              <span>Мощность</span>
              <div style="padding-top: 24px;">{{ momentPower }}</div>
            </div>
            <div class="col-12 col-md-auto">
              <div class="search-restrictions">
                <label for="search-restrictions-input">Процент ограничения</label>
                <input title="search" type="text" v-model="restrictionPercent" id="search-restrictions-input">
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div class="search-restrictions">
                <label for="search-restrictions-input">Ограничение в kW</label>
                <input title="search" type="text" v-model="restrictionKw" id="search-restrictions-input-kw">
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div class="confirm-restrictions">
                <div class="confirm confirm-restrictions__button count-restrictions__button" style="width:auto;" @click="countRestrictions()">OK</div>
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div class="confirm-restrictions">
                <div class="confirm confirm-restrictions__button" @click="applyRestrictions()">Применить ограничения</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 index-table-col">
          <table v-if="stations !== null" class="index-table restriction-table">
            <tr>
              <th class="th-signal">
                <div class="restriction-checkbox-div">
                  <input type="checkbox" v-model="selectAll" id="restriction-checkbox-all">
                  <label for="restriction-checkbox-all"></label>
                </div>
              </th>
              <th class="th-name th-name-restrictions">
                <span>Фотогальваническая система</span>
                <input v-model="titleSearch" type="text" title="Название">
              </th>
              <th class="th-name th-name-restrictions">
                <span>Область</span>
                <select title="Область" v-model="selectedRegion">
                  <option v-bind:value="null">Все</option>
                  <option v-for="region in regions" v-bind:key="region" v-bind:value="region">
                    {{ region }}
                  </option>
                </select>
              </th>
              <th class="th-power-peak"><span>Тип контроля</span></th>
              <th class="th-power-peak"><span>Мощность kW</span></th>
              <th class="th-power-today"><span>Ограничить до kW</span></th>
              <th class="th-last-update"><span>Текущая Мощность kW</span></th>
              <th class="th-last-update">
                <span>Текущее ограничение</span>
                <br>
                <span style="color: orange" v-if="restrictionsLoading">(загрузка...)</span>
              </th>
            </tr>
            <tr v-for="stationTable in sortByRegionAndName(stations)" v-bind:key="stationTable.id" @click="restrictionSelectItem()">
              <td>
                <div class="restriction-checkbox-div">
                  <!--suppress HtmlFormInputWithoutLabel -->
                  <input class="restriction-checkbox-input" type="checkbox" v-model="selected" :value="stationTable.id" :id="'restriction-checkbox-' + stationTable.id">
                  <label :for="'restriction-checkbox-' + stationTable.id"></label>
                </div>
              </td>
              <td>
                <a href="#">
                  {{ stationTable.name }} ({{ stationTable.totalPower }} MW)
                </a>
              </td>
              <td>
                <a href="#">
                  {{ stationTable.region }} обл.
                </a>
              </td>
              <td v-on:click.stop>
                <div><span>Тип контроля kW</span><b></b><i>
                  <div v-if="stationTable.type">
                    <select title="Тип контроля" v-model="stationTable.type">
                      <option v-for="type in mapTypes(stationTable.powerTypeControl.allowed)" v-bind:key="type.id" v-bind:value="type.id">
                        {{ type.label }}
                      </option>
                    </select>
                    <div
                      @click="setPowerTypeControl(stationTable.id, stationTable.type)"
                      class="confirm confirm-restrictions__button count-restrictions__button"
                      style="width: auto;"
                    >OK</div>
                  </div>
                  <div v-else>
                    <i style="color: grey; font-size: 13px;">(не задано) {{stationTable.type}}</i>
                  </div>
                </i></div>
              </td>
              <td>
                <div><span>Мощность kW</span><b></b><i>
                  {{
                    round(parseFloat(String(stationTable.totalPower)
                      .replace(',', '.')) * 1000)
                  }}
                </i></div>
              </td>
              <td>
                <div><span>Ограничить до kW</span><b></b>
                  <i>{{ calculateRestriction(stationTable.id) }}</i>
                </div>
              </td>
              <td>
                <div><span>Текущая Мощность kW</span><b></b><i>
                  {{ round(stationTable.currentPower) }}
                </i></div>
              </td>
              <td>
                <div><span>Текущее ограничение</span><b></b>
                  <i v-if="restrictions.hasOwnProperty(stationTable.id)">{{ restrictions[ stationTable.id ] }}</i>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import collection from 'lodash/collection'
import StationAPI from '../../api/station'
import Vue from 'vue'
import flatPickr from 'vue-flatpickr-component'
import '../../../node_modules/flatpickr/dist/themes/dark.css'
import moment from 'moment'

export default {
  name: 'RestrictionsTable',
  components: {
    flatPickr
  },
  data () {
    return {
      subtract: [],
      currentTab: 0,
      tabs: [
        {
          id: 0,
          title: 'Вручную'
        },
        {
          id: 1,
          title: 'От момента'
        }
      ],
      stations: null,
      polling: [],
      restrictionsLoading: false,
      regions: [],
      selectedRegion: null,
      titleSearch: '',
      selected: [],
      restrictions: {},
      restrictionPercent: 0,
      restrictionKw: 0,
      restricted: [],
      currentCalculate: [],
      stationId: null,
      dateTime: null,
      momentPower: null,
      momentPowers: null,
      dateTimeText: null,
      pickerConfig: {
        dateFormat: 'Y-m-d H:i:S',
        maxDate: new Date(),
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters[ 'station/isLoading' ]
    },
    hasError () {
      return this.$store.getters[ 'station/hasError' ]
    },
    error () {
      return this.$store.getters[ 'station/error' ]
    },
    user () {
      return this.$store.getters[ 'user/hasUser' ] ? this.$store.getters[ 'user/user' ] : {
        isSuper: false
      }
    },
    selectAll: {
      get: function () {
        return this.stations ? this.selected.length === this.stations.length : false
      },
      set: function (value) {
        let selected = []

        if (value) {
          this.stations.forEach(function (station) {
            selected.push(station.id)
          })
        }

        this.selected = selected
      }
    }
  },
  created () {
    StationAPI.findRestrictable()
      .then((r) => {
        this.stations = r.data
        this.loadRegions()

        this.stations.forEach(s => {
          StationAPI.findStationRestriction(s.id)
            .then(r => {
              Vue.set(this.restrictions, s.id, r.data.value)
              this.polling.push(setInterval(() => {
                StationAPI.findStationRestriction(s.id)
                  .then(r => {
                    Vue.set(this.restrictions, s.id, r.data.value)
                  })
              }, 45 * 1000))
            })
        })

        this.stations.forEach(s => {
          if (s.powerTypeControl !== null) {
            StationAPI.findPowerTypeControl(s.id).then(r => {
              Vue.set(s, 'type', r.data.value)
            })
          }
        })
      })
  },
  beforeDestroy () {
    this.polling.forEach(interval => {
      clearInterval(interval)
    })
  },
  methods: {
    clickTabs (tabName) {
      this.currentTab = tabName
    },
    typeControl (station) {
      return station.powerControlType || ''
    },
    setPowerTypeControl (id, type) {
      StationAPI.setPowerTypeControl(id, type).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Успех',
          text: 'Тип установлен'
        })
      }).catch(e => {
        this.$notify({
          group: 'foo',
          title: 'Ошибка!',
          text: 'Тип не применился'
        })
      })
    },
    mapTypes (allowedTypes) {
      let r = []
      allowedTypes.forEach(type => {
        if (Number(type) === 4) {
          r.push({
            id: '4',
            label: 'Операційна безпека'
          })
        } else if (Number(type) === 1) {
          r.push({
            id: '1',
            label: 'Рівнорозподілене керування'
          })
        } else if (Number(type) === 2) {
          r.push({
            id: '2',
            label: 'EOV main'
          })
        } else if (Number(type) === 3) {
          r.push({
            id: '3',
            label: 'EOV reserve'
          })
        }
      })
      return r
    },
    restrictionSelectItem () {
      let checkboxElement = event.target.closest('tr')
        .getElementsByClassName('restriction-checkbox-input')[ 0 ]
      checkboxElement.click()
    },
    applyRestrictions () {
      let restrictions = this.restricted.filter(r => this.selected.includes(r.id))
        .filter(r => this.sortByRegionAndName(this.stations)
          .map(station => station.id)
          .includes(r.id))

      if (restrictions.length > 0) {
        let _this = this
        this.$store.dispatch('common/toggleLoading', true)
        StationAPI.saveRestrictions(restrictions)
          .then((r) => {
            _this.$store.dispatch('common/toggleLoading', false)
            if (r.data.length === restrictions.length) {
              _this.$notify({
                group: 'foo',
                title: 'Ошибка!',
                text: 'Ограничения не применены'
              })
            } else if (r.data.length > 0) {
              _this.$notify({
                group: 'foo',
                title: 'Успех',
                text: 'Ограничения сохранены не на всех станциях'
              })
            } else {
              _this.$notify({
                group: 'foo',
                title: 'Успех',
                text: 'Ограничения сохранены'
              })
            }
          })
          .catch((error) => {
            this.$store.dispatch('common/toggleLoading', false)
            _this.$notify({
              group: 'foo',
              title: 'Ошибка!',
              text: error
            })
          })
      }

      this.selected = []
    },
    countRestrictions () {
      this.restricted = []
      this.sortByRegionAndName(this.stations)
        .forEach((station) => {
          if (this.selected.includes(station.id)) {
            let value = this.round(parseFloat(String(station.totalPower)
              .replace(',', '.')) * 1000 * this.restrictionPercent / 100)
            if (this.restrictionKw > 0) {
              value = parseInt(this.restrictionKw)
            }
            this.restricted[ station.id ] = {
              id: station.id,
              limitPower: value
            }
          }
        })
    },
    calculateRestriction (id) {
      if (this.restricted.hasOwnProperty(id)) {
        return this.restricted[ id ].limitPower
      } else {
        return null
      }
    },
    calculateMoment (id) {
      if (this.momentPowers !== null) {
        if (this.momentPowers.hasOwnProperty(id)) {
          return this.momentPowers[ id ]
        }
      }
      return null
    },
    calculateRestrictions () {
      this.getPowers()
      if (this.momentPowers === null) {
        return
      }
      this.restricted = []
      this.stations.forEach((station) => {
        if (this.selected.includes(station.id)) {
          if (this.momentPowers.hasOwnProperty(station.id)) {
            let value = this.momentPowers[station.id] - this.subtractRestrictions(station.id)
            if (value < 0) {
              value = 0
            }
            this.restricted[ station.id ] = {
              id: station.id,
              limitPower: value
            }
          }
        }
      })
    },
    round (val) {
      return Math.round(val)
    },
    loadRegions () {
      let values = []
      this.stations.forEach(station => {
        values.push(station.region)
      })
      this.regions = values.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    },
    sortByRegionAndName (inverters) {
      let result = collection.orderBy(inverters, [
        'region',
        'name'
      ], [
        (this.sortAsc ? 'asc' : 'desc'),
        (this.sortAsc ? 'asc' : 'desc')
      ])

      if (this.selectedRegion !== null) {
        result = result.filter(station => {
          return station.region === this.selectedRegion
        })
      }
      if (this.titleSearch.length > 0) {
        result = result.filter(station => {
          return String(station.name)
            .toLowerCase()
            .includes(this.titleSearch.toLowerCase())
        })
      }
      return result
    },
    getPower () {
      if (this.stationId !== null && this.dateTime !== 0) {
        let _this = this
        StationAPI.getStationPowerByMoment({
          'stationId': this.stationId,
          'dateTime': this.dateTime
        })
          .then((r) => {
            if (r.data.error === '') {
              _this.momentPower = r.data.power
            } else {
              _this.$notify({
                group: 'foo',
                title: 'Ошибка!',
                text: r.data.error
              })
            }
          })
        console.log(this.stationId + ' ' + this.dateTime)
      }
    },
    getPowers () {
      if (this.selected.length > 0 && this.dateTimeText !== null) {
        let _this = this
        let dateTime = moment(this.dateTimeText, 'DD.MM.YYYY, HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        StationAPI.getStationPowersByMoment({
          'stationIds': this.selected,
          'dateTime': dateTime
        })
          .then((r) => {
            if (r.data.error === '') {
              _this.momentPowers = r.data.powers
            } else {
              _this.$notify({
                group: 'foo',
                title: 'Ошибка!',
                text: r.data.error
              })
            }
          })
      }
    },
    subtractRestrictions (id) {
      if (this.subtract.hasOwnProperty(id)) {
        return parseInt(this.subtract[id])
      }
      return 0
    }
  }
}
</script>

<style>
.index-table td div i.inv.warn b:first-child {
  background: #eabe43;
}
</style>
